import { el } from 'redom';

import TextInputRow from 'generics/components/text-input-row';

import OptionsEditor from '../base';
import RequiredInputRow from '../required-input-row';

class FileFieldOptionsEditor extends OptionsEditor {

  constructor(configuration) {

    super(configuration);

    this.el = el('.text-field-options-editor-main', [
      this.renderButtonTextInputRow(),
      this.renderRequiredAttributeInputRow()
    ]);

  }

  renderButtonTextInputRow() {

    return new TextInputRow({
      label: 'Button text',
      placeholder: 'Please upload image',
      value: this.fieldRow.options.buttonText,
      onChange: this.handleButtonTextInputChange.bind(this)
    });

  }

  renderRequiredAttributeInputRow() {

    return new RequiredInputRow({
      checked: this.fieldRow.options.required,
      onChange: this.handleRequiredAttributeChange.bind(this)
    });

  }

  handleButtonTextInputChange(event, buttonText) {

    this.fieldRow.options.buttonText = buttonText;

    this.propogateFieldOptionsChange();

  }

  handleRequiredAttributeChange(required) {

    this.fieldRow.options.required = required;

    this.propogateFieldOptionsChange();

  }

}

export default FileFieldOptionsEditor;